import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useWindowDimensions, View, Text, ScrollView} from 'react-native';
import {useDispatch, useSelector} from 'react-redux';
import {useCssStyle} from '../../customHook/getCssStyle';
import CustomFlatList from '../customFlatList';
import CustomPressable from '../customPressable/customPressable';
import {ImageComp} from '../Image/Image';
import {CHEVRON_RIGHT} from '../../assets';
import RenderHTML from 'react-native-render-html';
import {useNavigation} from '@react-navigation/native';
import {useTranslation} from 'react-i18next';
import {
  setGoHome,
  setShowLoginModal,
} from '../../Redux/Reducers/appConfigReducer';
import {formatDate} from '../../js/formatDate';
import {formatLocalTime} from '../../js/utility';
import {GUEST_ITINERARY, GUEST_ITINERARY_DETAILS} from '../../navigation/StackNavigator/routes';
import { getCleanUrl } from '../../utils/Helper';
import { setCurrentWidget } from '../../Redux/Reducers/deviceConfigReducer';

const GuestItineraryWidget = ({listItemData=[], handleOnWidgetClick}) => {
  const getStyles = useCssStyle();
  const {width} = useWindowDimensions();
  const navigation = useNavigation();
  const {t} = useTranslation();
  const dispatch = useDispatch();

  const {isLoggedIn} = useSelector(state => state.appConfigSlice);
  const { isBookingFound } = useSelector(state => state.checkInSlice.bookingStatus);

  const guestItineraryList = useSelector(
    state => state.guestItinerarySlice.guestItineraryList,
  );

  const [filteredSortedList, setFilteredSortedList] = useState([]);

  useEffect(()=>{
    if(!guestItineraryList?.length){
      return;
    }
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const list =  guestItineraryList
      .filter(item => {
        const itemDate = new Date(item.itineraryDate);
        itemDate?.setHours(0, 0, 0, 0);
        return itemDate >= today;
      })
      .sort((a, b) => new Date(a?.itineraryDate) - new Date(b?.itineraryDate));

      setFilteredSortedList(list);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  },[guestItineraryList])

  // console.log("guest itinerary :",guestItineraryList, filteredSortedList, listItemData)


  const formatDateTime = dateString => {
    const date = new Date(dateString);

    // Need to be resolved!
    // const today = props.serverTimeDate ? new Date(props.serverTimeDate.split("T")[0]) : new Date(); 
    const today = new Date();

    today.setHours(0, 0, 0, 0);
    date.setHours(0, 0, 0, 0);

    const oneDayInMilliseconds = 24 * 60 * 60 * 1000;
    const diffInTime = date.getTime() - today.getTime();
    const diffInDays = diffInTime / oneDayInMilliseconds;

    if (diffInDays === 0) {
      return 'Today';
    } else if (diffInDays === -1) {
      return 'Yesterday';
    } else if (diffInDays === 1) {
      return 'Tomorrow';
    } else {
      return formatDate(new Date(dateString), "dddd MMMM Do", true);
    }
  };

  const handleListAll = () => {
    if (!isLoggedIn) {
      dispatch(setShowLoginModal(true));
      return;
    }
    // handleOnWidgetClick(listItemData[0]);

    dispatch(setCurrentWidget(listItemData[0]))
    navigation.navigate(GUEST_ITINERARY)
  };

  // Handle guest itinerary details
  const handleItemClick = item => {
    navigation.navigate(GUEST_ITINERARY_DETAILS, {item});
  };

  
  const renderList = (listItem)=>{
    const item = listItem?.item;

    const itineraries = item.itineraries;
    
    if(!item){
      return
    }
    return <View
            style={getStyles([
              'guestItineraryWidgetContainer',
              `guestItineraryWidgetContainer_${item?.id}`,
            ])}
            id={`guestItineraryWidgetContainer guestItineraryWidgetContainer_${item?.id}`}>

            {itineraries?.map((item)=><>
            <View style={getStyles(["guestItineraryWidgetItemContainer"])} id='guestItineraryWidgetItemContainer' >
                <View style={getStyles(["guestItineraryWidgetItemImageContainer"])} id='guestItineraryWidgetItemImageContainer'>
                  {<ImageComp source={getCleanUrl(item.imageUri)} style={getStyles(["guestItineraryWidgetItemImage"])} id="guestItineraryWidgetItemImage" />}
                </View>
                <View style={getStyles(["guestItineraryWidgetTitleTextContainer"])} id='guestItineraryWidgetTitleTextContainer'>
                  {item?.itineraryName && (
                    <Text
                    style={getStyles([
                      'guestItineraryWidgetTitle',
                      `guestItineraryWidgetTitle_${item?.id}`,
                    ])}
                    numberOfLines={1}
                    id={`guestItineraryWidgetTitle guestItineraryWidgetTitle_${item?.id}`}>
                      {item?.itineraryName}
                    </Text>
                  )}
                  {item?.itineraryDateTime && (
                    <Text
                      style={getStyles([
                        'guestItineraryWidgetDescription',
                        `guestItineraryWidgetDescription_${item.id}`,
                      ])}
                      id={`guestItineraryWidgetDescription guestItineraryWidgetDescription_${item.id}`}
                      numberOfLines={2}>
                      {formatLocalTime(
                        new Date(item.itineraryDateTime),
                      )}
                    </Text>
                  )}
                  {item?.itinerarySubTitle && <Text
                    style={getStyles([
                      'guestItineraryWidgetSubTitle',
                      `guestItineraryWidgetSubTitle_${item?.id}`,
                    ])}
                    numberOfLines={1}
                    id={`guestItineraryWidgetSubTitle guestItineraryWidgetSubTitle_${item?.id}`}>
                      {item?.itinerarySubTitle}
                    </Text>}

                </View>
               </View>


              <View
                style={getStyles([
                  'guestItineraryWidgetArrow_container',
                  `guestItineraryWidgetArrow_container_${item?.id}`,
                ])}
                id={`guestItineraryWidgetArrow_container guestItineraryWidgetArrow_container_${item?.id}`}>
                <ImageComp
                  source={CHEVRON_RIGHT}
                  style={getStyles([
                    'guestItineraryWidgetArrow',
                    `guestItineraryWidgetArrow_${item?.id}`,
                  ])}
                  id={`guestItineraryWidgetArrow guestItineraryWidgetArrow_${item?.id}`}
                />
              </View>
            </>)}
          </View>
  }

  const customWidgetTitleStyle = useMemo(() => {
    const style = getStyles(['guestItineraryWidgetTitleText']);
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const customWidgetSubTitleStyle = useMemo(() => {
    const style = getStyles(['guestItineraryWidgetSubTitleText']);
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const customWidgetSubTitleStyle2 = useMemo(() => {
    const style = getStyles(['guestItineraryWidgetSubTitleText2']);
    return Array.isArray(style) ? Object.assign({}, ...style) : style || {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

 
  return (
    <View
      style={getStyles([
        'widgetRootContainer',
        'guestItineraryWidgetRootContainer',
      ])}
      id="widgetRootContainer guestItineraryWidgetRootContainer"
    >
      <View 
        style={getStyles([ 'widgetmainContainer', 'guestItineraryWidgetMainContainer'])}
        id='widgetmainContainer guestItineraryWidgetMainContainer'
      >
        <View style={getStyles(['widgetmainContainerHeaderContainer', 'guestItineraryWidgetHeaderContainer'])} id='widgetmainContainerHeaderContainer guestItineraryWidgetHeaderContainer'>
          <View style={getStyles(['widgetmainContainerHeaderTitleContainer', 'guestItineraryWidgetTitleContainer'])} id='widgetmainContainerHeaderTitleContainer guestItineraryWidgetTitleContainer'>
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetTitleStyle}
                source={{ html: listItemData[0]?.displayName }}
                systemFonts={[customWidgetTitleStyle.fontFamily]}
                id="guestItineraryWidgetTitleText"
              />
              
            <CustomPressable
              onPress={handleListAll}
              style={getStyles(['guestItineraryWidgetTitleViewAll'])}
              disabled={filteredSortedList?.length ? false : true}
              id="guestItineraryWidgetTitleViewAll"
            >
              <Text
                style={getStyles(['guestItineraryWidgetViewAllTxt'])}
                id="guestItineraryWidgetViewAllTxt">
                {t('guest_itinerary.view_all')}
              </Text>
              <View
                style={getStyles(['guestItineraryWidgetTitleArrow_container'])}
                id={`guestItineraryWidgetTitleArrow_container`}>
                <ImageComp
                  source={CHEVRON_RIGHT}
                  style={getStyles(['guestItineraryWidgetTitleArrow'])}
                  id={`guestItineraryWidgetTitleArrow`}
                />
              </View>
            </CustomPressable>
          </View>
          <RenderHTML
            contentWidth={width}
            baseStyle={customWidgetSubTitleStyle2}
            source={{ html: listItemData[0]?.widgetDesc }}
            systemFonts={[customWidgetSubTitleStyle2.fontFamily]}
            id="guestItineraryWidgetSubTitleText2"
          />
        </View>

        <View style={getStyles(['widgetmainContainer', 'guestItinerarymainContainer'])} id="widgetmainContainer guestItinerarymainContainer">
          {!(isLoggedIn || isBookingFound) ? (
            <CustomPressable onPress={handleListAll}>
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetSubTitleStyle}
                source={{
                  html: t('guest_itinerary.widget_description_logged_out'),
                }}
                systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                id="guestItineraryWidgetSubTitleText"
              />
            </CustomPressable>
          ) : (
            !filteredSortedList?.length && (
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetSubTitleStyle}
                source={{
                  html: t('guest_itinerary.no_upcoming_reservations'),
                }}
                systemFonts={[customWidgetSubTitleStyle.fontFamily]}
                id="guestItineraryWidgetSubTitleText"
              />
            )
          )}

        
          {filteredSortedList?.length  ? 
          <ScrollView style={getStyles(['widgetmainContainerChildContainer', 'guestItineraryWidgetMainContainerChildContainer'])} id='widgetmainContainerChildContainer guestItineraryWidgetMainContainerChildContainer' showsVerticalScrollIndicator={false}>
            {filteredSortedList.map((item, index)=>(
              <CustomPressable
                key={index}
                onPress={() => handleItemClick(item)}
                style={getStyles([
                  'guestItineraryWidgetsWidgetContainer',
                  `guestItineraryWidgetsWidgetContainer_${item.itineraries[0].id}`,
                ])}
                id={`guestItineraryWidgetsWidgetContainer guestItineraryWidgetsWidgetContainer_${item.itineraries[0].id}`}
              >
                <>
                  <View style={getStyles(['guestItineraryWidgetHeaderTitleContainer'])} id='guestItineraryWidgetHeaderTitleContainer'>
                    <Text style={getStyles(['guestItineraryWidgetHeaderTitle'])} id='guestItineraryWidgetHeaderTitle'>{formatDateTime(new Date(item.itineraryDate))}</Text>
                  </View>
                  
                  {item.itineraries && <CustomFlatList
                    data={item.itineraries}
                    renderItem={renderList}
                    keyExtractor={item => item.id?.toString()}
                    showsVerticalScrollIndicator={false}
                  />}
                </>
              </CustomPressable>
            ))}
          </ScrollView> : null}


          {guestItineraryList?.length ? (<CustomPressable
            onPress={handleListAll}
            style={getStyles(['primaryBtn', 'guestItineraryViewAllButtonContainer'])}
            disabled={guestItineraryList?.length ? false : true}
            id="primaryBtn"
          >
            <Text
              style={getStyles(['primaryBtnTxt', 'guestItineraryViewAllButton'])}
              id="primaryBtnTxt">
              {t('guest_itinerary.view_all_button')}
            </Text>
          </CustomPressable>): null}
        </View>
      </View>
    </View>
  );
};

export default GuestItineraryWidget;
